import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";
import './modal_info_sanierungsfahrplan.css';

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';
import { ModalClose } from '../components/modal-close.tsx';

export default function ModalInfoSanierungsfahrplan() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Was bedeutet individueller Sanierungsfahrplan (iSFP)?</h1>
            <p id="modal-description">Maßnahmen, die im individuellen Sanierungsfahrplan (iSFP) empfohlen werden, erhalten eine höhere Förderung. Für die erste Wohneinheit steigen die förderfähigen Kosten von 30.000 € auf 60.000 €. Die Kosten über 30.000 € werden zusätzlich mit einem iSFP-Bonus von 5 % gefördert.</p>            
            <figure>
                <legend>BEG-Einzelmaßnahme Beispielrechnung Einfamilienhaus</legend>
                <table className="isptable" cellSpacing="0" cellpadding="0" border="0"> 
                <tr>
                    <th>förderfähige Investitionskosten je Wohneinheit</th>
                    <th>ohne iSFP 15% Zuschuss (max. auf. 30.000 €)</th>
                    <th>mit iSFP 20% Zuschuss  (max. auf. 60.000 €)</th>
                    <th>iSFP-Bonus 5%</th>
                    <th>Zuschuss mit iSFP-Bonus</th>
                </tr>
                <tr>
                    <td>30.000 €</td>
                    <td>4.500 €</td>
                    <td>4.500 €</td>		
                    <td>0 €</td>
                    <td>4.500 €</td>
                </tr>
                <tr>
                    <td>35.000 €</td>
                    <td>4.500 €</td>
                    <td>5.250 €</td>		
                    <td>250 €</td>
                    <td>5.500 €</td>
                </tr>
                <tr>
                    <td>40.000 €</td>
                    <td>4.500 €</td>
                    <td>6.000 €</td>		
                    <td>500 €</td>
                    <td>6.500 €</td>
                </tr>
                <tr>
                    <td>45.000 €</td>
                    <td>4.500 €</td>
                    <td>6.750€</td>		
                    <td>750 €</td>
                    <td>7.500 €</td>
                </tr>
                <tr>
                    <td>50.000 €</td>
                    <td>4.500 €</td>
                    <td>7.500 €</td>		
                    <td>1.000 €</td>
                    <td>8.500 €</td>
                </tr>
                <tr>
                    <td>55.000 €</td>
                    <td>4.500 €</td>
                    <td>8.250 €</td>		
                    <td>1.250 €</td>
                    <td>9.500 €</td>
                </tr>
                <tr>
                    <td>60.000 €</td>
                    <td>4.500 €</td>
                    <td>9.000 €</td>		
                    <td>1.500 €</td>
                    <td>10.500 €</td>
                </tr>
                </table>
            </figure>
           
             <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

